import React, { useEffect, useState } from 'react';
import { RoleFitSearchParams } from '../../../../models/overmind/search-params';
import { useAppActions, useAppState } from '../../../../overmind';
import { RoleFitContent } from '../role-fit-content/role-fit-content';
import { DataPoint } from '../../../../components/charts/recharts.models';
import { transformScores } from './top-employee-role-fit.helpers';

export function TopEmployeeRoleFitWidget({ roleSlug, peopleSlugs }: { roleSlug: string | undefined; peopleSlugs: string[] }): JSX.Element {
  const actions = useAppActions();
  const { companyVariables } = useAppState();

  const [loading, setLoading] = useState<boolean>(false);
  const [dataPoints, setDataPoints] = useState<DataPoint[]>();

  useEffect(() => {
    async function getData() {
      if (!roleSlug || !peopleSlugs?.length) return;

      setLoading(true);

      const searchParams: RoleFitSearchParams = {
        companySlug: companyVariables.slug!,
        roleSlug,
        learnerSlugs: peopleSlugs,
      };
      const response = await actions.analyticsGetRoleFitAverage(searchParams);
      setDataPoints(transformScores(response ?? [], companyVariables));

      setLoading(false);
    }

    getData();
  }, [roleSlug, peopleSlugs, companyVariables.slug]);

  return <RoleFitContent title="Top employee role-fit" subtitle="The average expected proficiency of the role's skills compared to the user's average score for these skills" roleSlug={roleSlug} peopleSlugs={peopleSlugs} isLoading={loading} data={dataPoints} fill={['baby-blue', 'bright-pink']} />;
}
